import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[iesAutofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  @Input() iesAutofocus: boolean | null | undefined = true;

  constructor(private element: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit(): void {
    if (this.iesAutofocus) {
      this.element.nativeElement.focus();
    }
  }
}
